import { runCordovaPluginCall } from '@helpers/cordovaBridge';

// In-memory only: rerun for existing signed-in users on every app launch,
// including the first launch after an update. Do not persist or log the email.
const attempts = new Map<string, Promise<boolean>>();

export function clearFirebaseOnDeviceMeasurement(): void {
  attempts.clear();
}

export function initializeFirebaseOnDeviceMeasurement(
  userId?: string | number | null,
  email?: string | null
): Promise<boolean> {
  if (typeof window === 'undefined' || (window as any).cordova?.platformId !== 'ios') {
    return Promise.resolve(false);
  }
  const plugin = (globalThis as any).FirebasePlugin;
  if (!userId || typeof email !== 'string' || !plugin?.initiateOnDeviceConversionMeasurement) {
    return Promise.resolve(false);
  }
  const emailAddress = email.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) { return Promise.resolve(false); }
  const key = JSON.stringify([String(userId), emailAddress]);
  const existing = attempts.get(key);
  if (existing) { return existing; }

  const attempt = new Promise<boolean>(resolve => {
    let finished = false;
    const finish = (success: boolean) => {
      if (finished) { return; }
      finished = true;
      window.clearTimeout(timeout);
      resolve(success);
    };
    const timeout = window.setTimeout(() => finish(false), 1000);
    try {
      const started = runCordovaPluginCall('FirebasePlugin.initiateOnDeviceConversionMeasurement', () => {
        // Consent for this use is covered by the app's existing consent flow.
        // This is the dedicated native API, not an Analytics event parameter.
        plugin.initiateOnDeviceConversionMeasurement({emailAddress}, () => finish(true), () => finish(false));
        return true;
      }, false);
      if (!started) { finish(false); }
    } catch (_) {
      // Analytics must never fail sign-in, and native errors can contain PII.
      finish(false);
    }
  });
  attempts.set(key, attempt);
  attempt.then(success => {
    if (!success && attempts.get(key) === attempt) { attempts.delete(key); }
  });
  return attempt;
}



// WEBPACK FOOTER //
// ./src/services/firebase/firebaseOnDeviceMeasurement.ts